module.exports = __webpack_public_path__ + "static/media/GEO-1.0291e071.png";